import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, Subject, takeUntil } from "rxjs";
import { Pageable } from "../../../models/pageable-mode";
import { AppFilter } from "../../../models/app-filter.model";
import { Pessoa } from "../../../models/pessoa.model";
import { Veiculo } from "../../../models/veiculo.model";
import { AbVeiculo } from "app/abstract/full-pages/veiculo/veiculo.abstract";

@Injectable({ providedIn: 'root' })
export class VeiculoService extends AbVeiculo implements OnDestroy {

  public pageable: Pageable = new Pageable();
  public filter: AppFilter = new AppFilter();
  public pessoa: Pessoa = new Pessoa();
  public veiculo: Veiculo = new Veiculo();

  private readonly destroy$ = new Subject();

  public pessoas: BehaviorSubject<Array<Pessoa>> = new BehaviorSubject<Array<Pessoa>>([]);

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public deletarVeiculo(id: number) {
    return this.delete('veiculos/', id);
  }

  public getVeiculo(id: number) {
    return this.get('veiculos/', id);
  }

  public saveVeiculo(veiculo) {
    return this.save('veiculos/', veiculo);
  }

  public getAllVeiculosUnidade(filter: AppFilter) {
    return this.get("veiculos/filter_unidade/", filter.encode())
      .pipe(takeUntil(this.destroy$)).subscribe((data: any) => this.pageable = data);
  }

  public getAllVeiculosPessoaUnidade(pessoaUnidadeId: number): Observable<any> {
    return this.get(`veiculos/pessoa_unidade/${pessoaUnidadeId}`);
  }

  public getAllVeiculosVinculadosUnidade(unidadeId: number): Observable<any> {
    return this.get(`veiculos/pessoa_unidade_veiculos/${unidadeId}`);
  }

  public getAllVeiculosVinculadosPessoaUnidadesDaPessoa(): Observable<any> {
    return this.get(`veiculos/veiculos_pessoa_unidade`);
  }

  public getAllVeiculosPessoa(pessoaId: number): Observable<any> {
    return this.get(`veiculos/pessoa/${pessoaId}`);
  }

  public getAllMarcasVeiculos(pessoaUnidadeId: number, tipoVeiculo: String): Observable<any> {
    return this.get(`veiculos/marcas_veiculos/${pessoaUnidadeId}/tipoveiculo/${tipoVeiculo}`);
  }

  public getMarcasVeiculosPessoaId(pessoaId: number, tipoVeiculo: String): Observable<any> {
    return this.get(`veiculos/marcas_veiculos/pessoa_id/${pessoaId}/tipoveiculo/${tipoVeiculo}`);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
